var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'displayed' : _vm.display == true },attrs:{"id":"print-area"}},[_c('div',{attrs:{"id":_vm.id}},[_c('div',{staticClass:"my-3"},[_vm._t("default")],2),_c('footer')])])
}
var staticRenderFns = []

export { render, staticRenderFns }